import React from 'react';
import * as S from './styles';

const Slide8: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.CustomSubtitle>
        Bustier, R$ 36.250, e hot pants, R$ 2.946, ambos Dolce & Gabbana. Colar,
        Tiffany & Co., R$ 36.750. Meia calça, Calzedonia, R$ 109.
      </S.CustomSubtitle>
    </S.Container>
  );
};

export { Slide8 };
